export const PageText = {
  _1: 'How to get an aircheckr access token?',
  _2: 'You get your personal aircheckr access token. Manage it in your personal account page.'
};

export const Categories = {
  _1: {
    title: 'Personal access token',
    subcategories: [
      {
        key: 0,
        subtitle: 'Sign up/in',
        text: 'You first have to <a href="/signup">register</a>. If you are already registered, just <a href="/login">sign in</a> and go to your personal account page. There you can see your personal access token. You can use the same token for all our REST APIs and widgets.'
      },
      {
        key: 1,
        subtitle: 'Validity',
        text: 'Your token stays yours for as long as you are registered. What you can do with this token, depends on your plan/license. Check out our different subscription plans <a href="/pricing">here</a>.'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/help-and-guides/how-to-get-aircheckr-token_page.js